import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation } from 'swiper/modules'; // Commented out since we only have one slide
import 'swiper/css';
// import 'swiper/css/navigation'; // Commented out since navigation is disabled
import './OfficeSlider.css';
import hanoveroffice from './apc-hanover.jpeg';
// import weymouthoffice from './mainstlocation.jpeg'; // Commented out for future use

const OfficeSlider = () => {
    
    
    
    const handleMapClick = (mapUrl) => {
        window.open(mapUrl, '_blank', 'noopener,noreferrer');
    };
    
    // Only Hanover office is active, Weymouth office commented out for future use
    const offices = [
        {
            image: hanoveroffice,
            name: "Hanover, MA Office",
            description: "Our Hanover facility offers comprehensive primary care services in a welcoming environment. Conveniently located on Webster Street, we provide easy access to quality healthcare with ample parking.",
            address: "105 Webster St Suite 9, Hanover, MA 02339",
            mapUrl: "https://maps.app.goo.gl/n1FBhxoD8u51u4aX8"
        }
        // Weymouth office commented out for future use
        // {
        //     image: weymouthoffice,
        //     name: "Weymouth, MA Office",
        //     description: "Located in the heart of Weymouth, our trusted medical center provides personalized care with access to a full range of diagnostic services and wheelchair accessiblity. Our facility features comfortable waiting areas and designated consultation rooms designed for your comfort.",
        //     address: "851 Main St Suite 25, Weymouth, MA 02190",
        //     mapUrl: "https://maps.app.goo.gl/9MMucpuUm9Szo2vu6"
        // }
    ];

    return (
        <div className="office-slider-container">
            <Swiper
                // modules={[Autoplay, Navigation]} // Commented out since we only have one slide
                spaceBetween={0}
                slidesPerView={1}
                slidesPerGroup={1}
                loop={false} // Disabled loop since we only have one slide
                allowTouchMove={false} // Disabled touch move since we only have one slide
                // autoplay disabled since we only have one slide
                // autoplay={{
                //     delay: 4000,
                //     disableOnInteraction: false,
                // }}
                navigation={false} // Disabled navigation since we only have one slide
                className="office-slider"
                style={{ 
                    height: 'auto', 
                    minHeight: '400px',
                    width: '100%'
                }}
                onSlideChange={(swiper) => {
                    
                }}
            >
                {offices.map((office, index) => (
                    <SwiperSlide key={index} style={{ height: 'auto' }}>
                        <div className="office-slide">
                            <img 
                                src={office.image} 
                                alt={office.name} 
                                className="office-image"
                                style={{ 
                                    display: 'block !important', 
                                    visibility: 'visible !important', 
                                    opacity: '1 !important',
                                    width: 'calc(100% - 20px)',
                                    maxHeight: '400px',
                                    minHeight: '280px',
                                    objectFit: 'cover',
                                    borderRadius: '18px',
                                    margin: '10px 10px 15px 10px'
                                }}
                                onError={(e) => {
                                    
                                    e.target.style.backgroundColor = '#f0f0f0';
                                    e.target.style.minHeight = '250px';
                                    e.target.innerHTML = 'Image not found';
                                }}
                                onLoad={() => {
                                    
                                }}
                            />
                            <div className="office-info">
                                <h4>{office.name}</h4>
                                <p className="office-description">{office.description}</p>
                                <p className="office-address">{office.address}</p>
                                <button 
                                    onClick={() => handleMapClick(office.mapUrl)} 
                                    className="learn-more-btn"
                                >
                                    View on Map
                                </button>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default OfficeSlider;
